"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _red.default;
  }
});
Object.defineProperty(exports, "pink", {
  enumerable: true,
  get: function get() {
    return _pink.default;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function get() {
    return _purple.default;
  }
});
Object.defineProperty(exports, "deepPurple", {
  enumerable: true,
  get: function get() {
    return _deepPurple.default;
  }
});
Object.defineProperty(exports, "indigo", {
  enumerable: true,
  get: function get() {
    return _indigo.default;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _blue.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function get() {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function get() {
    return _cyan.default;
  }
});
Object.defineProperty(exports, "teal", {
  enumerable: true,
  get: function get() {
    return _teal.default;
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _green.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function get() {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function get() {
    return _lime.default;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function get() {
    return _yellow.default;
  }
});
Object.defineProperty(exports, "amber", {
  enumerable: true,
  get: function get() {
    return _amber.default;
  }
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function get() {
    return _orange.default;
  }
});
Object.defineProperty(exports, "deepOrange", {
  enumerable: true,
  get: function get() {
    return _deepOrange.default;
  }
});
Object.defineProperty(exports, "brown", {
  enumerable: true,
  get: function get() {
    return _brown.default;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function get() {
    return _grey.default;
  }
});
Object.defineProperty(exports, "blueGrey", {
  enumerable: true,
  get: function get() {
    return _blueGrey.default;
  }
});

var _red = _interopRequireDefault(require("@material-ui/core/colors/red"));

var _pink = _interopRequireDefault(require("@material-ui/core/colors/pink"));

var _purple = _interopRequireDefault(require("@material-ui/core/colors/purple"));

var _deepPurple = _interopRequireDefault(require("@material-ui/core/colors/deepPurple"));

var _indigo = _interopRequireDefault(require("@material-ui/core/colors/indigo"));

var _blue = _interopRequireDefault(require("@material-ui/core/colors/blue"));

var _lightBlue = _interopRequireDefault(require("@material-ui/core/colors/lightBlue"));

var _cyan = _interopRequireDefault(require("@material-ui/core/colors/cyan"));

var _teal = _interopRequireDefault(require("@material-ui/core/colors/teal"));

var _green = _interopRequireDefault(require("@material-ui/core/colors/green"));

var _lightGreen = _interopRequireDefault(require("@material-ui/core/colors/lightGreen"));

var _lime = _interopRequireDefault(require("@material-ui/core/colors/lime"));

var _yellow = _interopRequireDefault(require("@material-ui/core/colors/yellow"));

var _amber = _interopRequireDefault(require("@material-ui/core/colors/amber"));

var _orange = _interopRequireDefault(require("@material-ui/core/colors/orange"));

var _deepOrange = _interopRequireDefault(require("@material-ui/core/colors/deepOrange"));

var _brown = _interopRequireDefault(require("@material-ui/core/colors/brown"));

var _grey = _interopRequireDefault(require("@material-ui/core/colors/grey"));

var _blueGrey = _interopRequireDefault(require("@material-ui/core/colors/blueGrey"));